module.exports = __webpack_public_path__ + "static/media/LocationMarker.eeb1a9c4.svg";